module.exports = __webpack_public_path__ + "040fc86c6af9bae482829a555672234f.jpg";